import React, { ReactNode } from "react";

import Tooltip from "components/Tooltip";

type Props = {
  icon: React.ReactNode;
  title: string;
  className?: string;
  children?: ReactNode;
  maxWidth?: number | string;
  sectionName?: string;
  shouldShowTooltip?: boolean;
  tooltipText?: string;
};

const TooltipCTA = ({
  icon,
  title,
  children,
  className,
  maxWidth = 350,
  sectionName = "",
  shouldShowTooltip = true,
  tooltipText,
}: Props) => (
  <div
    className={`flex p-sm text-xs font-bold bg-leafly-white rounded-full justify-between mb-md ${className}`}
    style={{ maxWidth }}
    data-testid="tooltip-cta"
  >
    <div className="flex items-center">
      <div className="mr-sm">{icon}</div>
      <span>{title}</span>
    </div>
    {shouldShowTooltip && (!!tooltipText || children) && (
      <Tooltip
        dialogClass="-left-[292px] top-[24px] w-[288px]"
        text={tooltipText}
        placement="top-right"
        tooltipId={`show-${sectionName}-tooltip`}
      >
        {children}
      </Tooltip>
    )}
  </div>
);

export default TooltipCTA;
